import type { CadenzaUrl } from 'cadenza/utils/cadenza-url/cadenza-url';
import { cadenzaUrl } from 'cadenza/utils/cadenza-url/cadenza-url';
import { ajax } from 'cadenza/api-client/api';
import { getCurrentHierarchyParameters } from 'cadenza/api-client/processing-param-util';
import { MIMETYPE_JSON } from 'cadenza/model/media-type';

interface ReportConfigDto {
  title: string;
  hasResult: boolean;
  recordsTotal: number; // 0
  uniqueRecordsTotal: number; // -1
  isResultTruncated: boolean;
  isReportCanceled: boolean;
  renderFormats: RenderFormatDto[];
  hasInsufficientRepositoryConfig: boolean;
}

interface RenderFormatDto {
  defaultExtension: string;
  mimeType: string;
  url: string;
}

interface GeneratedReportDto {
  readonly serverFileRef: string;
  readonly downloadFileName: string;
}

export function getReportFilename (url: string, abortSignal: AbortSignal): Promise<GeneratedReportDto> {
  return ajax(url, {
    type: 'POST',
    contentType: MIMETYPE_JSON,
    signal: abortSignal
  });
}

export function getReportDownloadUrl (serverFileRef: string, downloadFileName: string, mimeType: string): CadenzaUrl {
  const urlSearchParams = new URLSearchParams();
  urlSearchParams.append('serverFileRef', serverFileRef);
  urlSearchParams.append('downloadFileName', downloadFileName);
  urlSearchParams.append('mimetype', mimeType);
  urlSearchParams.append('inline', 'true');
  return cadenzaUrl(`/pages/download/get?${urlSearchParams}`);
}

export function getReportConfig (): Promise<ReportConfigDto> {
  const urlParams = new URLSearchParams(window.location.search);
  // selector is required to exist
  const selector: string = urlParams.get('selector')!;
  const processings = urlParams.getAll('processings');
  const conditionHash = urlParams.get('conditionValuesSetHash');
  const hierarchyParams = getCurrentHierarchyParameters();
  const params = new URLSearchParams();
  params.append('selector', selector);
  for (const processing of processings) {
    params.append('processings', processing);
  }
  if (conditionHash) {
    params.append('conditionValuesSetHash', conditionHash);
  }
  if (hierarchyParams) {
    for (const [ name, value ] of Object.entries(hierarchyParams)) {
      params.append(name, value);
    }
  }
  return ajax(`/processingChain/report/config?${params.toString()}`);
}
